import log from 'salvo-lite/log'
import 'dom-slider'

class ProxyDropdown {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._elems = {
            selected: elem.querySelector('[data-proxy-dropdown-selected]'),
            selectedInner: elem.querySelector('[data-proxy-dropdown-selected-inner]'),
            list: elem.querySelector('[data-proxy-dropdown-list]'),
            listItems: elem.querySelectorAll('[data-proxy-dropdown-list-item]'),
            bundleInput: elem.querySelector('[data-bundle-selected-product]')
        }
        this._options = {
            listItemDisabledClass: 'proxy-dropdown__item--disabled',
            selectedDisabledClass: 'proxy-dropdown__selected--disabled'
        }
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        this._elems.selected.addEventListener('click', () => this._toggleList())

        this._elems.listItems.forEach(listItem => {
            listItem.addEventListener('click', () => {
                this._toggleList()
                this._updateSelected(listItem)
            })
        })

        document.body.addEventListener('click', e => {
            if (!e.target.closest('[data-proxy-dropdown]') && e.target !== this._elem) this._closeList()
        })
    }

    _toggleList () {
        // let isOpen = this._elems.list.classList.contains('open')
        // this._elems.list.classList.toggle('open')
        // this._elem.classList.toggle('proxy-dropdown--open')
        if (this._elems.list.classList.contains('open')) {
            this._elems.list.classList.remove('open')
            this._elem.classList.remove('proxy-dropdown--open')
        } else {
            document.querySelectorAll('[data-proxy-dropdown-list]').forEach(listItem => {
                listItem.classList.remove('open')
            })
            document.querySelectorAll('[data-proxy-dropdown]').forEach(listItem => {
                listItem.classList.remove('proxy-dropdown--open')
            })
            this._elems.list.classList.add('open')
            this._elem.classList.add('proxy-dropdown--open')
        }
        // if (isOpen) return
        // this._elems.list.classList.add('open')
        // this._elem.classList.add('proxy-dropdown--open')
    }

    _closeList () {
        if (this._elems.list) this._elems.list.classList.remove('open')
        if (this._elems) this._elem.classList.remove('proxy-dropdown--open')
    }

    _updateSelected (listItem) {
        const {selected, selectedInner} = this._elems
        const {listItemDisabledClass, selectedDisabledClass} = this._options

        selectedInner.innerHTML = listItem.innerHTML
        listItem.classList.contains(listItemDisabledClass) ? selected.classList.add(selectedDisabledClass) : selected.classList.remove(selectedDisabledClass)

        if (this._elems.bundleInput) {
            this._elems.bundleInput.value = listItem.previousElementSibling.value
        }
    }
}

export default ProxyDropdown



// WEBPACK FOOTER //
// ./src/resources/scripts/components/ProxyDropdown.js